import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";

export const uploadLeadsListV2 = async (body: FormData) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/import-leads/import-lists`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      formData: true,
      data: body,
    },
  });
};
